import { webApiClient } from 'tradera/utils/http';
import type {
    GetAliasSuggestionsApiRequest,
    GetAliasSuggestionsApiResponse
} from 'tradera/state/services/types/webapi-member-generated';

export async function getAliasSuggestions(
    params: GetAliasSuggestionsApiRequest
): Promise<string[]> {
    const response = await webApiClient.post<
        GetAliasSuggestionsApiResponse,
        GetAliasSuggestionsApiRequest
    >('/member/registration/alias-suggestions', params, {
        cancelTokenId: 'aliasSuggestions'
    });

    if (!response?.data?.suggestions) {
        return [];
    }

    return response.data.suggestions;
}
